import { render, staticRenderFns } from "./image-search.vue?vue&type=template&id=1ad5b806&shadow"
import script from "./image-search.vue?vue&type=script&lang=js&shadow"
export * from "./image-search.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports